var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],attrs:{"type":"range","min":_vm.min,"max":_vm.max,"step":_vm.step},domProps:{"value":(_vm.value)},on:{"__r":function($event){_vm.value=$event.target.value}}}),_c('p',[_vm._v(_vm._s(_vm.scaledValue))])])
}
var staticRenderFns = []

export { render, staticRenderFns }